module.exports = __webpack_public_path__ + "static/media/wire.fd95cf55.png";


//////////////////
// WEBPACK FOOTER
// ./src/semantic/dist/themes/fibrestream/assets/images/wire.png
// module id = 991
// module chunks = 0